import { useDecision } from '@optimizely/react-sdk'

import {
  COPAYNOL_INDIA_PAYMENT_METHOD_OPTIONS,
  SHOULD_SHOW_ALL_INDIA_PAYMENT_METHOD_OPTIONS,
  SHOULD_SHOW_GENERAL_RAZORPAY_CHECKOUT_OPTION,
  SHOULD_SHOW_ALL_RAZORPAY_CHECKOUT_OPTIONS,
  SHOULD_SHOW_ALL_RAZORPAY_CHECKOUT_OPTIONS_WITH_SUBMETHOD,
  SHOULD_SHOW_RAZORPAY_BASELINE,
} from 'constants/optimizely'

export interface RazorpayExperimentData {
  shouldShowAllIndiaPaymentMethodOptions: boolean
  shouldShowRazorpayBaseline: boolean
  shouldShowGeneralRazorpayOption: boolean
  shouldShowAllRazorpayOptions: boolean
  shouldShowAllRazorpayOptionsWithSubmethod: boolean
}

// TODO: Remove enabled check when Optimizely variations have been configured for A/B testing.
// Currently used to deliver baseline in staging/prod while integration testing in TST. Agnes Aronsson 2023-03-14
export function useRazorpayExperiment(): RazorpayExperimentData {
  const [{ enabled, variationKey }] = useDecision(COPAYNOL_INDIA_PAYMENT_METHOD_OPTIONS)

  const shouldShowAllIndiaPaymentMethodOptions =
    enabled && variationKey === SHOULD_SHOW_ALL_INDIA_PAYMENT_METHOD_OPTIONS
  const shouldShowRazorpayBaseline = !enabled || variationKey === SHOULD_SHOW_RAZORPAY_BASELINE
  const shouldShowGeneralRazorpayOption =
    variationKey === SHOULD_SHOW_GENERAL_RAZORPAY_CHECKOUT_OPTION
  const shouldShowAllRazorpayOptions = variationKey === SHOULD_SHOW_ALL_RAZORPAY_CHECKOUT_OPTIONS
  const shouldShowAllRazorpayOptionsWithSubmethod =
    variationKey === SHOULD_SHOW_ALL_RAZORPAY_CHECKOUT_OPTIONS_WITH_SUBMETHOD

  return {
    shouldShowAllIndiaPaymentMethodOptions,
    shouldShowRazorpayBaseline,
    shouldShowGeneralRazorpayOption,
    shouldShowAllRazorpayOptions,
    shouldShowAllRazorpayOptionsWithSubmethod,
  }
}
